import { BACKEND } from "../variables.js";
import axios from "axios";

const UNIFIED_LOGIN = BACKEND + "/auth/login";
const REFRESH_PROFILE = BACKEND + "/auth/refreshProfile";

export default {
  state: {},
  getters: {},
  mutations: {},
  actions: {
    UNIFIED_LOGIN(state, payload) {
      return axios({
        method: "POST",
        url: UNIFIED_LOGIN,
        data: payload,
      });
    },
    REFRESH_ADMIN_PROFILE(state, payload) {
      return axios({
        method: "POST",
        url: REFRESH_PROFILE,
        headers: { Authorization: payload.token },
      });
    },
  },
};
